<template>
  <span class="multiselect-wrapper">
    <multiselect
      :disabled="disabled"
      track-by="_id"
      :value="selectedItem"
      label="name"
      :placeholder="$t('file-approval-survey.member.assignee')"
      :options="options"
      :searchable="true"
      :allow-empty="allowEmpty"
      :show-labels="false"
      @input="changed"
      @search-change="search = $event"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <div class="d-flex">
          <letter-avatar :name="option.name" :image="option.avatar" variant="primary"> </letter-avatar>
          <span class="ml-2">
            {{ option.name }}
            <div class="text-muted">
              <span v-if="option.email"> {{ option.email }}</span>
              <span v-else-if="option.credential"> {{ option.credential.email }}</span>
            </div>
          </span>
        </div>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div class="d-flex">
          <letter-avatar :name="option.name" :image="option.avatar" variant="primary"> </letter-avatar>
          <span class="ml-2">
            {{ option.name }}
            <div class="text-muted">
              <span v-if="option.email"> {{ option.email }}</span>
              <span v-else-if="option.credential"> {{ option.credential.email }}</span>
            </div>
          </span>
        </div>
      </template>
      <slot v-if="isorganizationMembersLoading" slot="noOptions"> <content-loading /></slot>
      <slot v-else slot="noOptions">{{ $t("common.not-found") }}</slot>

      <slot slot="noResult">{{ $t("common.not-found") }}</slot>
    </multiselect>
  </span>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    selected: { type: [Array, Object], default: null },
    permissionFilter: { type: Array, default: null },
    organization: { type: Object, default: null },
    ignore: { type: Array, default: null },
    filterFunction: { type: Function, default: null },
    allowEmpty: { type: Boolean, default: false },
  }, //ignore:array of memberId
  data() {
    return { options: [], selectedItem: undefined, search: undefined };
  },
  computed: {
    isorganizationMembersLoading() {
      return this.$store.getters["organizationMember/isSearchLoading"];
    },
    currentAccount() {
      return this.$store.getters["user/account"];
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(v) {
        this.selectedItem = v;
      },
    },
    search: {
      deep: true,
      handler(v) {
        this.debounce(() => this.searchChanged(v));
      },
    },
  },
  async mounted() {
    this.searchChanged("*");
    if (this.selected) {
    }
  },
  methods: {
    async searchChanged(value) {
      value = (value == "*" ? "" : value).trim();

      const members = await this.fetchMembers(value);

      this.options = members;
    },

    changed(values) {
      let result = undefined;
      if (values) {
        if (Array.isArray(values)) {
          result = [...values];
        } else {
          result = { ...values };
        }
      }

      this.selectedItem = result; //! Probleme sebep olabilir

      delete result.processAdminOf;
      delete result.departmentAdminOf;

      if (result) {
        this.$emit("onAclSelect", result);
        this.$emit("onSelect", { ...result, _id: result.accountId });
      } else {
        this.$emit("onSelect", null);
      }

      this.$forceUpdate();
    },
    async fetchMembers(value) {
      const organization = this.organization ?? this.currentOrganization;
      const response = await this.$store.dispatch("organizationMember/paginateWithForSearch", {
        pagination: { query: { accessable: { value: true, isObject: true }, name: { value } }, options: { limit: 200 } },
        organizationId: organization?._id,
      });

      return this.prepareResponse(response);
    },
    prepareResponse(response) {
      let result =
        response?.data?.docs?.filter((i) => {
          if (i.accessable && this.permissionFilter) {
            if (i.isOwner && !(i.accountId == this.currentAccount._id)) {
              return true;
            }

            return i.roles?.find((r) => r.permissions?.some((p) => this.permissionFilter.includes(p)));
          }

          return i.accessable;
        }) ?? [];

      if (this.filterFunction) {
        result = result.filter(this.filterFunction);
      }

      if (!this.ignore) {
        return result;
      } else {
        return result.filter((i) => !this.ignore.includes(i._id));
      }
    },

    itemSelected(item) {
      this.selectedItem = item;
      delete item.processAdminOf;
      delete item.departmentAdminOf;

      if (item) {
        this.$emit("onAclSelect", item);
        this.$emit("onSelect", { ...item, _id: item.accountId });
      } else {
        this.$emit("onSelect", null);
      }
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
</style>
